import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private events = new Map<string, Subject<any>>();

  on<T>(eventName: string): Subject<T> {
    if (!this.events.has(eventName)) {
      this.events.set(eventName, new Subject<T>());
    }
    return this.events.get(eventName) as Subject<T>;
  }

  emit<T>(eventName: string, data?: T): void {
    if (this.events.has(eventName)) {
      this.events.get(eventName)!.next(data);
    }
  }

  off(eventName: string): void {
    if (this.events.has(eventName)) {
      this.events.get(eventName)!.complete();
      this.events.delete(eventName);
    }
  }
}
